import React from "react";

import { useUser } from "@components/user-context";
import {
  getNorthbeamUtmPlatformParams,
  NorthbeamUtmPlatform,
} from "@features/utm-guide";

export function AvantLink() {
  const { user } = useUser();
  const urlParamPairs = getNorthbeamUtmPlatformParams({
    platform: NorthbeamUtmPlatform.AVANT_LINK,
  });

  const emailBody = (
    <>
      <p>Hello,</p>
      <p>Please add the following UTM parameters to our ads:</p>
      <p>
        <b>
          {urlParamPairs.map(({ key, value }) => `${key}=${value}`).join("&")}
        </b>
      </p>
      <p>Thank you!</p>
    </>
  );

  return (
    <div className="flex flex-col gap-3">
      <p className="mb-0">
        You need to email <b>AvantLink&apos;s</b> customer support at{" "}
        <a href="mailto:support@avantlink.com">support@avantlink.com</a>. You
        can copy the below text for our suggested email message.
      </p>
      <div className="card">
        <div className="card-body">
          <p className="card-title">
            <b>Subject:</b> Please add UTM tracking parameters to ads from{" "}
            {user.companyName}.
          </p>
          <hr />
          <div className="card-text">{emailBody}</div>
        </div>
      </div>
    </div>
  );
}
